/* eslint-disable */
import React, { useState, useRef } from "react";
import _Input from "../../../generic/_Input";
import _Button from "../../../generic/_Button";
import Icon from "../../../Icon";
import Overlay from "react-bootstrap/Overlay";
import PropTypes from "prop-types";
import {dateFormat } from '../../../../utils/dateHelpers';
const RangeDate = (props) => {
  const { onChange, dateFrom, dateTo, errors, required } = props;
  const target = useRef(null);
  const [visible, setVisible] = useState(false);

  return (
    <div className="w-full">
       <div className="grid grid-cols-2 gap-4 border p-2 rounded-lg">
          <_Input
              value={dateFrom}
              onChange={(e) => {
                const value = {
                  target: {
                    name: "dateFrom",
                    value: e.target.value,
                  },
                };
                onChange(value);
              }}
              name="dateFrom"
              title="Desde"
              type="date"
              required
              isError={errors?.period?.dateFrom ? true : false}
              errors={errors?.period?.dateFrom ? errors?.period?.dateFrom : ""}
            />
            <_Input
              value={dateTo}
              onChange={(e) => {
                const value = {
                  target: {
                    name: "dateTo",
                    value: e.target.value,
                  },
                };
                onChange(value);
              }}
              name="dateTo"
              title="Hasta"
              type="date"
              required
              isError={errors?.period?.dateTo ? true : false}
              errors={errors?.period?.dateTo ? errors?.period?.dateTo : ""}
            />
       </div>
    </div>
  );
};

RangeDate.propTypes = {
  dateFrom: PropTypes.string,
  dateTo: PropTypes.string,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  required: PropTypes.bool,
};

export default RangeDate;
